import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { TopicGroupApi, topicgroupsApi } from "api/topicgroups/topicgroupsApi";
import { IDropdownOption } from "components/atoms";
import { QUERIES_KEYS } from "queries";

export const useTopicGroups = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "",
) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.TOPIC_GROUPS(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => topicgroupsApi.fetch(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.TOPIC_GROUPS(skip, limit, searchPhrase, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, topicGroups: data?.data.data ?? [], total: data?.data.total ?? 0 };
};

export interface TopicGroupOption extends IDropdownOption {
  topicGroup?: TopicGroupApi;
}
export const useTopicGroupsOptions = (filter: string = "", orderBy: string = "") => {
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.TOPIC_GROUPS(0, 1_000_000, "", filter, orderBy),
    queryFn: () => topicgroupsApi.fetch(0, 1_000_000, "", filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const options: TopicGroupOption[] = (data?.data.data ?? []).map((x) => ({
    value: x.id.toString(),
    label: x.name,
    topicGroup: x,
  }));

  return { loading: isLoading, options };
};
